export const links = {
    undergrad: {
        BGS: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html',
        BEd: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education/about.html',
        BEdSecond: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education-as-a-second-degree/about.html',
        minors: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html',
        counsellingHumanDevelopmentMinor: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors/counselling-human-development-minor.html',
        undergradCourses: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html',
    },
    teacherEd: {
        PDP: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html',
        PDPFrench: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html',
        PLP: 'https://www.sfu.ca/education/programs/teacher-ed/plp/about.html',
        PLPFrench: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html',
        AHCOTE: 'https://www.sfu.ca/education/programs/teacher-ed/ahcote/about.html',
        PQP: 'https://www.sfu.ca/education/programs/teacher-ed/pqp/about.html',
        HEART: 'https://www.sfu.ca/education/programs/teacher-ed/heart/about.html',
    },
    professionalStudies: {
        GDE: 'https://www.sfu.ca/education/programs/diplomas/gde.html',
        PBD: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html',
        PBDs: {
            postBachDiplomaCounsellingHumanDev: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html',
            frenchAndEducation: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html',
            earlyLearning: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/early-learning-pbd.html',
            enviroEducation: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/env-education-pbd.html',
            educationGeneral: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/education-gen-pbd.html',
            specialEducation: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/special-ed-pbd.html',
        }
    },
    graduateStudies: {
        MEdEP: ' https://www.sfu.ca/education/programs/graduate-studies/programs/edpracticefp.html',
        mastersDegreePrograms: 'https://www.sfu.ca/education/programs/graduate-studies.html',
        counsellingPsychMAMEd: 'https://www.sfu.ca/education/programs/graduate-studies/programs/counspsych.html',
        areasOfStudy: {
            artsEducation: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/arts-ed.html',
            counsellingPsych: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/c-psych.html',
            curriculimInstruction: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/ci.html',
            equityStudies: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/equity.html',
            educationalLeadership: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/edu-leader.html',
            educationalPsych: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/ed-psy.html',
            eduTechLearningDesign: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/ed-tech.html',
            languageSocieties: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/lang.html',
            mathsEducation: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/math.html',
            programmesLanguesFrancaise: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/en-langue-francaise.html',
            themesInCommunity: 'https://www.sfu.ca/education/programs/graduate-studies/areas-of-study/themes.html'
        }
    }
}
